module.exports = __webpack_public_path__ + "static/img/qrcode.baf906ab.png";